/* eslint-disable import/no-unused-modules */
import { atom, useAtom } from 'jotai'
import { useAtomValue, useSetAtom } from 'jotai'
import { useCallback } from 'react'

const accountDrawerOpenAtom = atom(false)
const showMoonpayTextAtom = atom(false)

export function useToggleAccountDrawer() {
  const [open, updateAccountDrawerOpen] = useAtom(accountDrawerOpenAtom)
  const setShowMoonpayTextInDrawer = useSetShowMoonpayText()

  return useCallback(() => {
    updateAccountDrawerOpen(!open)
    if (open) {
      setShowMoonpayTextInDrawer(false)
    }
  }, [open, setShowMoonpayTextInDrawer, updateAccountDrawerOpen])
}

export function useCloseAccountDrawer() {
  const updateAccountDrawerOpen = useSetAtom(accountDrawerOpenAtom)
  return useCallback(() => updateAccountDrawerOpen(false), [updateAccountDrawerOpen])
}

export function useAccountDrawer(): [boolean, () => void] {
  const accountDrawerOpen = useAtomValue(accountDrawerOpenAtom)
  return [accountDrawerOpen, useToggleAccountDrawer()]
}

// Only show Moonpay text if the user opens the Account Drawer by clicking 'Buy'
export function useSetShowMoonpayText() {
  const updateShowMoonpayText = useSetAtom(showMoonpayTextAtom)
  return useCallback((newValue: boolean) => updateShowMoonpayText(newValue), [updateShowMoonpayText])
}

export function useShowMoonpayText(): boolean {
  const showMoonpayText = useAtomValue(showMoonpayTextAtom)
  return showMoonpayText
}
